<template>
  <div class="dashboard" style="">

    <el-card class="feedback-card" style="font-size: 30px;">
      <div class="stats">
        <div class="stat-boxx">
          <div>
            <el-tooltip  effect="light" content="本周答疑次数" placement="top">
              <p style="text-align: center; font-weight: 900; ">本周答疑次数</p>
            </el-tooltip>
            <p style="text-align: center; font-weight: 900; font-size: 25px;">{{ weeklyAnswerCount }}</p>
          </div>
        </div>
        <div class="stat-boxx" style="border-left: 1px solid #ffffff;">
          <div>
            <el-tooltip  effect="light" content="本周答疑次数" placement="top">
              <p style="text-align: center; font-weight: 900; ">累计答疑次数</p>
            </el-tooltip>
            <p style="text-align: center; font-weight: 900; font-size: 25px;">{{ totalAnswerCount }}</p>
          </div>
        </div>
      </div>

      <div class="filters">
        <el-form  :model="forms" class="demo-form-inline"  style="display: flex;flex-wrap: wrap;">
          <el-form-item label="创建时间：" style="display: flex;margin-right: 20px;">
            <el-date-picker
              v-model="forms.createTimeStart"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择开始时间"
              style="width: 200px;"
            ></el-date-picker>
            <span style="margin: 0px 10px;">至</span>
            <el-date-picker
              v-model="forms.createTimeEnd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择结束时间"
              style="width: 200px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="学科名称：" style="display: flex;margin-right: 20px;">
            <el-select v-model="forms.subject" placeholder="请选择" filterable clearable>
              <el-option
                v-for="item in subjects"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课老师：" style="display: flex;margin-right: 20px;">
            <el-select v-model="forms.teacher" placeholder="请选择" filterable clearable>
              <el-option
                v-for="item in teachers"
                :key="item.teacherId"
                :label="item.teacherName"
                :value="item.teacherId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="答疑时间：" style="display: flex;margin-right: 20px;">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="forms.answerTimeStart"
              type="date"
              placeholder="选择开始时间"
              style="width: 200px;"
            ></el-date-picker>
            <span style="margin: 0px 10px;">至</span>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="forms.answerTimeEnd"
              type="date"
              placeholder="选择结束时间"
              style="width: 200px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="width: 100%; text-align: end;">
            <el-button size="small"  class="btns" type="primary" @click="search">搜索</el-button>
            <el-button size="small"  class="btns" type="primary" @click="clearFilters">清除</el-button>
            <el-button size="small"  class="btns" type="primary" @click="addRecord">添加</el-button>
            <el-button size="small"  class="btns" type="primary" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="tableData" height="700" :empty-text="noDataText" style="width: 100%; margin-top: 20px; " :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
        <el-table-column prop="studentName" label="学生">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.studentName" placement="top">
              <p style="text-align: center;">{{ scope.row.studentName }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="executiveTeacherName" label="老师">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.executiveTeacherName" placement="top">
              <p style="text-align: center;">{{ scope.row.executiveTeacherName }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="学科">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.categoryName" placement="top">
              <p style="text-align: center;">{{ scope.row.categoryName }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="gradeName" label="年级">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.gradeName" placement="top">
              <p style="text-align: center;">{{ scope.row.gradeName }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="taskName" label="任务名称">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.taskName" placement="top">
              <p style="text-align: center;">{{ scope.row.taskName }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="expirationDate" label="答疑时间">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.expirationDate + ' - ' +  scope.row.expirationStartDate  + ' - ' + scope.row.expirationEndDate" placement="top">
              <p style="text-align: center;">{{ scope.row.expirationDate + ' - ' +  scope.row.expirationStartDate  + ' - ' + scope.row.expirationEndDate }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="successPlan" label="老师答疑情况" width="150px">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.successPlan === 1 ? '进行中' : scope.row.successPlan === 2 ? '已完成' :  '待完成'" placement="top">
              <p style="text-align: center;">{{ scope.row.successPlan === 1 ? '进行中' : scope.row.successPlan === 2 ? '已完成' :  '待完成' }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="handlingResult" label="答疑反馈">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.handlingResult" placement="top">
              <p style="text-align: center;">{{ scope.row.handlingResult }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="marketSuccess" label="销售完成情况" width="150px">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.marketSuccess === 1 ? '未完成' : scope.row.marketSuccess === 2 ? '已完成' :  '未操作'" placement="top">
              <p style="text-align: center;">{{ scope.row.marketSuccess === 1 ? '未完成' : scope.row.marketSuccess === 2 ? '已完成' :  '未操作'  }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.createTime" placement="top">
              <p style="text-align: center;">{{ scope.row.createTime }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="taskUserName" label="创建人">
          <template v-slot="scope">
            <el-tooltip  effect="light" :content="scope.row.taskUserName" placement="top">
              <p style="text-align: center;">{{ scope.row.taskUserName }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template v-slot="scope">
            <el-button @click="handleView(scope.$index, scope.row)" type="text" size="small">查看</el-button>
            <el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>


      <div class="pagination-container" style="text-align: center;  margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
      </div>


    </el-card>



    <el-dialog :visible="showpopLong" center :title="showpopLongtitle" modal-append-to-body append-to-body :close-no-click-modal="false" :before-close="showpopLongCloseDialog" width="60%" >

      <div class="add-form">
        <el-form :model="form"  ref="form" :disabled="showpopLongtitle ==='查看'">
          <el-form-item label="执行老师：" prop="teacher">
            <el-select v-model="form.teacher" placeholder="请选择老师" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in teachers"
                :key="item.teacherId"
                :label="item.teacherName"
                :value="item.teacherId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="任务名称：" prop="taskName">
            <!-- <el-input v-model="form.taskName" placeholder="请输入任务名称"></el-input> -->
            <el-select
              class="select"
              v-model="form.taskName"
              placeholder="请选择任务名称："
              style="width: 100%"
              filterable
              disabled
              clearable>
              <el-option
                v-for="source in TodoallList"
                :key="source.id"
                :value="source.id"
                :label="source.taskName"
              >
              </el-option>
            </el-select>


          </el-form-item>

          <el-form-item label="学生姓名：" prop="student">
            <el-select v-model="form.student" placeholder="请选择学生姓名" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in students"
                :key="item.id"
                :label="item.realname"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="学科名称：" prop="student">
            <el-select v-model="form.categoryId" placeholder="请选择学科名称" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in subjects"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="截止日期：" prop="deadline">
            <el-date-picker
              v-model="form.deadline"
              type="date"
              placeholder="选择截止日期"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="截止开始时间：" prop="startTime">
            <el-time-select
              v-model="form.startTime"
              placeholder="选择截止开始时间"
              style="width: 100%"
              :picker-options="{
                start: '06:00',
                step: '00:01',
                end: '24:00'
              }"
            ></el-time-select>
          </el-form-item>

          <el-form-item label="截止结束时间：" prop="endTime">
            <el-time-select
              v-model="form.endTime"
              placeholder="选择截止结束时间"
              style="width: 100%"
              :picker-options="{
                start: '06:00',
                step: '00:01',
                end: '24:00'
              }"
            ></el-time-select>
          </el-form-item>

          <el-form-item label="任务创建人：" prop="creator">
            <el-select v-model="form.creator" placeholder="请选择任务创建人" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in creators"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


        </el-form>


        <div style="text-align: center; margin-top: 20px;">
              <el-button size="small" type="primary" class="btns" v-if="showpopLongtitle !== '查看'" @click="submitForm('form')">保存</el-button>
              <el-button size="small" type="primary" class="btns" @click="resetForm('form')">取消</el-button>
        </div>

      </div>

    </el-dialog>


  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../../config/api";

import {
  ApiAddTodoTask,
  ApiGetTodoList,
  ApiAddTodoUpdate,
  ApiTodoDelete,
  ApiAddTodoall,
} from "../../../api/apiTask";

export default {
  props: {
    studentData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showpopLong: false,
      showpopLongtitle:'',
      currentPage: 1,
      pageSize: 10,
      total: 0,

      tableHeight: 400, // 表格高度
      noDataText: '暂无数据', // 无数据时显示的文本
      weeklyAnswerCount: 0,
      totalAnswerCount: 0,
      form: {
        teacher: '',
        taskName: 14,
        student: '',
        categoryId: '',
        deadline: '',
        startTime: '',
        endTime: '',
        creator: '',
      },
      forms:{
        createTimeStart: '',
        createTimeEnd: '',
        subject: '',
        teacher: '',
        answerTimeStart: '',
        answerTimeEnd: '',
      },

      subjects: [
        // { value: 'math', label: '数学' },
        // { value: 'english', label: '英语' },
        // { value: 'science', label: '科学' }
      ],
      teachers: [
        // { value: 'teacher1', label: '张老师' },
        // { value: 'teacher2', label: '李老师' },
        // { value: 'teacher3', label: '王老师' }
      ],
      tableData: [
        // 示例数据
        {
          student: '学生1',
          teacher: '张老师',
          subject: '数学',
          grade: '一年级',
          taskName: '任务1',
          answerTime: '2023-10-01',
          teacherAnswerSituation: '良好',
          answerFeedback: '满意',
          salesCompletionSituation: '已完成',
          createTime: '2023-10-01',
          creator: '管理员1'
        },
        // 更多数据...
      ],

      ruless: {
        teacher: [{ required: true, message: '请选择老师', trigger: 'change' }],
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        student: [{ required: true, message: '请选择学生姓名', trigger: 'change' }],
        deadline: [{ required: true, message: '请选择截止日期', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择截止开始时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择截止结束时间', trigger: 'change' }],
        creator: [{ required: true, message: '请选择任务创建人', trigger: 'change' }]
      },

      students: [
        // { value: 'student1', label: '学生1' },
        // { value: 'student2', label: '学生2' },
        // { value: 'student3', label: '学生3' }
      ],

      creators: [
        // { value: 'creator1', label: '管理员1' },
        // { value: 'creator2', label: '管理员2' },
        // { value: 'creator3', label: '管理员3' }
      ],

      TodoallList:[],

      studentsList_s:[],
      studentsList_ss:[],
    };
  },
  mounted() {

      this.form.student = this.studentData.id

      axios.get(`${apiBaseUrl}/studentFeedback/getCategoryList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.subjects = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })

      axios.get(`${apiBaseUrl}/studentFeedback/getTeacherList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.teachers = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })

      // axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
      //       this.creators = res.data.data
      //   }).catch(error => {
      //     this.$message.error(error)
      // })


      axios.get(`${apiBaseUrl}/teacher/allJob`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}) .then(response => {
        this.creators = response.data.data
      }).catch(error => {
        this.$message.error(error)
      })
      // axios.post(`${apiBaseUrl}/student/students`, { pageSize: 1000000, pageNum: 1, regionName: localStorage.getItem('cityTepy') },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      //   this.students = res.data.data.records
      // }).catch(err => {
      //   this.$message.error(err)
      // })

      axios.post(`${apiBaseUrl}/student/getStudentList`, { studentType: 1,},{headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
       let { data } = res;
       if (data.code == 200) {
          this.studentsList_s = data.data
          this.students = [...this.studentsList_s,...this.students]
       }else{
         this.studentsList_s = []
       }
      }).catch(err => {
        this.$message.error(err)
      })

      axios.post(`${apiBaseUrl}/student/getStudentList`, { studentType: 2,},{headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
       let { data } = res;
       if (data.code == 200) {
          this.studentsList_ss = data.data
          this.students = [...this.studentsList_ss,...this.students]
       }else{
         this.studentsList_ss = []
       }
      }).catch(err => {
        this.$message.error(err)
      })




      ApiAddTodoall().then((res) => {
        let { data } = res
        this.TodoallList = data
      })


      this.search()

  },
  methods: {
    submitForm() {

          let ruleForm = {
                executiveTeacher: this.form.teacher,
                studentId: this.form.student,
                taskId: this.form.taskName,
                categoryId: this.form.categoryId,
                taskUser: this.form.creator,
                expirationDate: this.form.deadline,
                expirationStartDate: this.form.startTime,
                expirationEndDate: this.form.endTime,
          }

          if(this.form.id){
            ruleForm.id = this.form.id
            ApiAddTodoUpdate(ruleForm).then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message);
                  this.search()
                  this.showpopLongtitle = ''
                  this.showpopLong = false
                  this.form = { teacher: '', taskName: '', student: '',  categoryId: '', deadline: '',  startTime: '', endTime: '', creator: '',}
                } else {
                  this.$message.error(res.message);
                }
            }).catch((error) => {
              this.$message.error(err)
            })
          }else{
            ApiAddTodoTask(ruleForm).then((res) => {
                if (res.code == 200) {
                  this.$message.success(res.message);
                  this.search()
                  this.showpopLongtitle = ''
                  this.showpopLong = false
                  this.form = { teacher: '', taskName: '', student: '',  categoryId: '', deadline: '',  startTime: '', endTime: '', creator: '',}
                } else {
                  this.$message.error(res.message);
                }
            }).catch((error) => {
              this.$message.error(err)
            })
          }

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showpopLong = false
    },
    showpopLongCloseDialog() {
      this.showpopLongtitle = ''
      this.showpopLong = false
    },
     handleSizeChange(newSize) {
      this.pageSize = newSize;
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
    search() {
      console.log('搜索:', this.form);

      let data = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startTime: this.forms.createTimeStart,
        endTime: this.forms.createTimeEnd,
        executiveTeacher: this.forms.teacher,
        startExpirationDate: this.forms.answerTimeStart,
        endExpirationDate: this.forms.answerTimeEnd,
        categoryId: this.forms.subject,
        studentId: this.studentData.id,
      }

      axios.post(`${apiBaseUrl}/todo/findAnswerPage`, data, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              let data = res.data.data.data

              if(data.records.length > 0){
                 this.tableData = data.records
              }else{
                this.tableData = []
              }

              this.currentPage = data.current
              this.pageSize = data.size
              this.total = data.total

              this.weeklyAnswerCount = res.data.data.weekNumber ? res.data.data.weekNumber : 0
              this.totalAnswerCount = res.data.data.sumNumber ? res.data.data.sumNumber : 0

              this.$message({ type: 'success', message: '获取数据成功!' })
          }else{
            this.$message({ type: 'error', message: '获取数据失败' })
          }

        }).catch((error) => {
          this.$message({ type: 'error', message: error })
     })


    },
    clearFilters() {
      // 清除过滤器
      this.forms = {
        createTimeStart: '',
        createTimeEnd: '',
        subject: '',
        teacher: '',
        answerTimeStart: '',
        answerTimeEnd: ''
      };

      this.currentPage = 1
      this.pageSize = 10
      this.search()
    },
    addRecord() {
      this.showpopLongtitle = '添加'
      this.showpopLong = true
      this.form.taskName = 14
      this.form.id = ''
    },
    exportData() {
      // this.$message({ type: 'info',  message: '占无'})
      let data = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startTime: this.forms.createTimeStart,
        endTime: this.forms.createTimeEnd,
        executiveTeacher: this.forms.teacher,
        startExpirationDate: this.forms.answerTimeStart,
        endExpirationDate: this.forms.answerTimeEnd,
        categoryId: this.forms.subject,
        studentId: this.studentData.id,
      }
      axios.post(`${apiBaseUrl}/todo/exportAnswerPage`, data, { responseType: "blob", headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",})
          const downloadLink = document.createElement("a")
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download = "日常答疑.xlsx"
          downloadLink.click()
      })
    },
    handleView(index, row) {

      this.form.teacher = row.executiveTeacher
      this.form.student = row.studentId
      this.form.taskName  = row.taskId ? row.taskId : 14
      this.form.categoryId = row.categoryId
      this.form.creator = row.creator
      this.form.deadline = row.expirationDate
      this.form.startTime = row.expirationStartDate
      this.form.endTime = row.expirationEndDate

      this.showpopLongtitle = '查看'
      this.showpopLong = true
      // 查看记录逻辑
    },
    handleEdit(index, row) {

      this.form.teacher = row.executiveTeacher
      this.form.student = row.studentId
      this.form.taskName  = row.taskId ? row.taskId : 14
      this.form.categoryId = row.categoryId
      this.form.creator = row.creator
      this.form.deadline = row.expirationDate
      this.form.startTime = row.expirationStartDate
      this.form.endTime = row.expirationEndDate

      this.form.id = row.id

      this.showpopLongtitle = '编辑'
      this.showpopLong = true
      // 编辑记录逻辑
    },
    handleDelete(index, row) {
      // 删除记录逻辑
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', { confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning' }).then(() => {
        ApiTodoDelete(row.id).then((res) => {
          this.$message({ message: "删除成功", type: "success" })
          if(res.data.code == 200){
            this.search()
            this.$message({ message: "删除成功", type: "success" })
          }else{
            this.$message({ message: res.data.meg, type: "error" })
          }
        }).catch((error) => {
          this.$message.error("删除失败")
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};
</script>


<style scoped>


.add-form {
  padding: 20px;
  width: 80%;
  margin: 0 auto;
}
.dashboard {
  padding: 20px;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-box {
  border: 1px solid #ddd;
  padding: 20px;
  width: 48%;
}

.stat-boxx {
  border: 1px solid #ddd;
  padding: 20px;
  width: 48%;
  position: relative;
  overflow: hidden;
}

.marquee-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.marquee-content {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 10s linear infinite;
}

.marquee-content1 {
  display: inline-block;
  white-space: nowrap;
  animation: marquee1 10s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}


@keyframes marquee1 {
  0% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.flow-border {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  border: 2px solid #ddd;
  animation: flow 5s linear infinite;
}

@keyframes flow {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.filters {
  margin-bottom: 20px;
}

.el-button {
  margin-right: 10px;
}

.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/subassembly/dailyAnswering.vue